export enum RedirectSource {
  line = 'LINE',
  web = 'Web',
  sms = 'SMS',
  other = 'Other',
  other2 = 'Other2'
}
